export * from './IconFlagFilled';
